import { createContext } from 'react';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = createContext();
export const LanguageContext = createContext();

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const formatDateWithEnglishNumerals = (date, options = {}) => {
  const defaultOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...options
  };
  return new Date(date).toLocaleDateString('en-GB', defaultOptions);
};

export const formatTimeWithEnglishNumerals = (date, options = {}) => {
  const defaultOptions = {
    hour: '2-digit',
    minute: '2-digit',
    ...options
  };
  return new Date(date).toLocaleTimeString('en-GB', defaultOptions);
};
